import { SearchScenariosFormModel } from '@app/scenarios/search-scenarios-form/search-scenarios-form.model';
import { SearchScenariosDTO } from './search-scanarios.dto';

export class SearchScenariosMapper {
  mapToDTO = (filters: SearchScenariosFormModel): SearchScenariosDTO => {
    return {
      zoneIds: filters.zoneIds,
      sourceIds: filters.sourceIds,
      basecaseIds: filters.basecaseIds,
      subtypeIds: filters.subtypeIds,
      weatherYearIds: filters.weatherYearIds || [],
      granularity: filters.granularity,
      lastPublicationDate: Number(filters.publicationDateType) === 1,
      beforeLastPublicationDate: Number(filters.publicationDateType) === 2,
      startPublicationDate: filters.startPublicationDate?.toISOString(),
      endPublicationDate: filters.endPublicationDate?.toISOString(),
      marketAreaIds: filters.marketAreaIds,
    };
  };
}
